import { render, staticRenderFns } from "./BadgesDefaults.vue?vue&type=template&id=709ecfc7&scoped=true"
import script from "./BadgesDefaults.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgesDefaults.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BadgesDefaults.vue?vue&type=style&index=0&id=709ecfc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ecfc7",
  null
  
)

export default component.exports